import React from "react";

import { UnauthorizedPage } from "@king-ict/eupisi-ui/components";
import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";
import { useTranslation } from "react-i18next";
import { Route, useHistory } from "react-router";

import { useCurrentUser } from "../hooks/authorization/useCurrentUser";
import { dashboard as dashboardRoute, adminWebAplicationUrl } from "./routes";

export const UnauthorizedPageRoute = () => {
  const user = useCurrentUser();

  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Route
      path={"/page-not-available"}
      render={() => (
        <UnauthorizedPage
          detailsText={
            user.roleId !== 0 && user.roleId !== KindergartenRoleEnum.Parent
              ? t("unauthorizedPage.adminDetailstext")
              : undefined
          }
          action={
            user.roleId !== 0
              ? () => {
                  if (
                    user.roleId !== KindergartenRoleEnum.Parent &&
                    adminWebAplicationUrl
                  ) {
                    window.location.href = adminWebAplicationUrl;
                  } else if (user.roleId === KindergartenRoleEnum.Parent) {
                    history.push(dashboardRoute());
                  }
                }
              : undefined
          }
        />
      )}
    />
  );
};
